import React from 'react'
import { SupplementalMedia } from 'Components/supplementalMedia'
import { TourGuide } from 'Components/tourGuide'
import { MainMedia } from 'Components/tourStop'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import { useSelector } from 'react-redux'
import { useGetLanguagesQuery } from 'Services/institution'

interface TourStopProps {
  stopData?: {
    stopid: number
    descriptionid: number
    description_id: number
    title: string
    stop_title: string
    main_media_id: number
    main_media_type: string
    media_id?: number
  }
  personalized?: boolean
}

export const TourStopContainer = ({
  stopData: {
    stopid: stopId,
    descriptionid: descriptionId,
    description_id: personalizedDescriptionId,
    title,
    stop_title: personalizedTitle,
    main_media_id: mainMediaId,
    main_media_type: mainMediaType,
    media_id: pointMediaId,
  },
  personalized,
}: TourStopProps) => {
  const { locId, instId } = useSelector((state: any) => state.location)
  const { data: allLangs } = useGetLanguagesQuery({
    instId,
    locId,
  })

  return (
    <>
      <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1-content'
          id='panel1-header'
        >
          <b style={{ paddingRight: '5px' }}>{title || personalizedTitle}</b>
          {personalized && (
            <>
              -{' '}
              <AutoAwesomeIcon
                sx={{ color: 'gold', paddingRight: '5px', paddingLeft: '5px' }}
              />{' '}
              For You
            </>
          )}
        </AccordionSummary>
        <AccordionDetails>
          <MainMedia id={mainMediaId} type={mainMediaType} pointMediaId={pointMediaId} stopId={stopId} stopTitle={title || personalizedTitle}/>
          {allLangs?.resources.map((lang) => (
            <TourGuide
              language={lang.language}
              descriptionId={descriptionId || personalizedDescriptionId}
            />
          ))}
          <Box component='div' sx={{ mb: 1 }}></Box>
          <SupplementalMedia stopId={stopId} mainMediaId={mainMediaId} />
        </AccordionDetails>
      </Accordion>
    </>
  )
}
